<template>
  <div>
    <!-- 菜单 -->
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input v-model="filters.ET_Name" placeholder="模板标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.ET_Type" placeholder="模板类型" >
            <el-option label="请选择模板类型" :value="-1"></el-option>
            <el-option
              v-for="item in options"
              :label="item.Name"
              :value="item.Value"
              :key="item.Value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!-- 列表 -->
    <el-table
      border=""
      :data="tabData"
      v-loading="listLoading"
      style="width: 100%">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column label="模板标题">
        <template slot-scope="scope">
          <span v-html="scope.row.ET_Name"></span>
        </template>
      </el-table-column>
      <el-table-column label="模板类型" width="180">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.ET_Type===0">报名成功</el-tag>
          <el-tag type="" v-else-if="scope.row.ET_Type===1">审核通过</el-tag>
          <el-tag type="success" v-else>电子门票</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="180"
        v-if="tableButtonList.length > 0"
      >
        <template slot-scope="scope">
          <span
            v-for="item in tableButtonList"
            :key="item.id"
            style="padding-left: 10px"
          >
            <el-button
              type="text"
              v-bind:key="item.id"
              v-prevent-re-click
              v-if="!item.IsHide"
              @click="callFunc(item, scope.row)"
              >{{ item.name }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    
    <!--工具条-->
    <el-pagination
      layout="total, sizes, prev, pager, next"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="filters.PageIndex"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="filters.PageSize"
      :total="filters.total"
      style="float: right"
    ></el-pagination>

    <!-- 新增模板 -->
    <el-dialog :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="75%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="模板名称" prop="ET_Name">
          <el-input v-model="ruleForm.ET_Name"></el-input>
        </el-form-item>
        <el-form-item label="模板类型" prop="ET_Type">
          <el-radio-group v-model="ruleForm.ET_Type">
            <el-radio
              v-for="item in options"
              :key="item.Value"
              :label="item.Value"
              >{{ item.Name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板内容" prop="ET_Content">
          <Tinymce
            ref="descTinymce"
            v-model="ruleForm.ET_Content"
            :accept="accept"
            :form="form"
            :model="model"
            style="width:99%"
          ></Tinymce>
        </el-form-item>
        <el-form-item class="submitBtn">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="submitCancel">取消</el-button>
        </el-form-item>

        <div class="divTag">
          <strong>标签说明</strong>
          <div class="tagList">
            
            <div v-for="item of placeholderList" :key="item.Name" v-html="item.Title+'：${'+item.Name+'}'"></div>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  ActivityNoticeTemplateList,
  AddOrUpdActivityTemplate,
  getActTemplateInfo,
  DelActTemplate,
  getTemplateTypes,
  getPlaceholderList,
} from '../../api/api'
import Tinymce from '@/components/Tinymce/index'
import { getButtonList } from '../../promissionRouter'
export default {
  data(){
    return {      
      topButtonList: [],
      tableButtonList: [],
      options:[], // 模板类型
      placeholderList:[], // 标签集合
      filters:{
        ET_Name:'',
        ET_Type:-1,
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData:[],
      listLoading: false,
      dialogVisible: false,
      dialogTitle:'',
      ruleForm:{
        TemplateIDStr:'',
        ET_Name:'',
        ET_Type:null,
        ET_Content:'',
      },
      rules:{
        ET_Name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        ET_Type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        ET_Content: [
          { required: true, message: '请输入模板内容', trigger: 'change' }
        ],
      },
      fileList: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept: '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PBG,.GIF',
    }
  },
  components: {
    Tinymce,
  },
  methods:{ 
    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 查询
    handleQuery(){
      this.listLoading = true
      ActivityNoticeTemplateList(this.filters).then((res) => {
        if(res.data.success) {
          this.tabData = res.data.response.data
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.listLoading = false
        } else {
          this.$message({
            type: 'warning',
            message: '接口获取失败'
          });
        }
      })
    },

    // 新增
    handleAdd(){
      this.dialogTitle='新增模板'
      this.dialogVisible = true
      this.initTinymce()
    },
    // 新增按钮
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if(valid) {
          AddOrUpdActivityTemplate(this.ruleForm).then((res) => {
            if(res.data.success) {
              this.$message({
                type: 'success',
                message: '模板添加成功!'
              });
              this.dialogVisible = false
              this.$refs[formName].resetFields()
              this.handleQuery();
            } else {
              this.$message({
                type: 'warning',
                message: res.data.msg
              });
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 取消按钮
    submitCancel(){
      this.dialogVisible = false
      this.$refs.ruleForm.resetFields()
    },

    //  编辑
    handleUpdate() {
      this.dialogTitle='编辑模板'
      this.dialogVisible = true
      getActTemplateInfo(this.currentRow.TemplateIDStr).then((res) => {
        if(res.data.success) {          
          this.$nextTick(() => {
            this.ruleForm = res.data.response
            this.initTinymce()
          })
        }
      })
    },
    // 删除
    handleDelete(){
      this.$confirm('请确认是否要删除此模板？', '提示', {
        confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
      })
        .then(() => {
          DelActTemplate(this.currentRow.TemplateIDStr).then((res) => {
            console.log(res)
            if(res.data.success) {
              this.$message({
                type: 'success',
                message: '删除成功！'
              });
              this.handleQuery()
            } else {
              this.$message({
                type: 'warning',
                message: '删除失败！'
              });
            }
          })
          
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    // 弹窗关闭
    handleClose() {
      this.dialogVisible = false
      this.$refs.ruleForm.resetFields()
    },
    initTinymce() {
      this.$refs.descTinymce.setContent(this.ruleForm.ET_Content)
    },
  },
  mounted(){
    this.handleQuery();
    // 获取模板类型
    getTemplateTypes().then((res) => {
      if(res.data.success) {
        this.options = res.data.response
      }      
    });

    getPlaceholderList().then((res) => {
      if(res.data.success) {
        this.placeholderList = res.data.response
      }    
    })

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  }
}
</script>

<style scoped>
  .divTag{
    border: 1px solid #e1e1e1;
    padding: 20px 20px;
    color: #656565;
    border-radius: 6px;
    background-color: rgba(244, 244, 244, .8);
  }
  .tagList{
    display: flex;
    flex-wrap: wrap;
  }
  .tagList strong{
    font-size: 14px;
  }
  .tagList div{
    width: 25%;
    margin-top: 15px;
    font-size: 14px;
  }

</style>